export default __webpack_public_path__ + "static/media/suppliers.9ed9c03f.png";